(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const veil = () => document.querySelector('.veil');

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
  }[char]));

  const money = (cents = 0) => new Intl.NumberFormat(
    document.documentElement.lang || 'en-US',
    {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }
  ).format(Number(cents) / 100);

  const toast = (message) => {
    const el = document.getElementById('PLToast');
    if (!el) return;

    el.textContent = message;
    el.classList.add('show');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('show'), 2400);
  };

  const getCart = () => fetch(`${root}cart.js`, {
    headers: { Accept: 'application/json' }
  }).then((response) => response.json());

  const updateCartCount = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
      el.classList.remove('pop');
      void el.offsetWidth;
      el.classList.add('pop');
    });

    document.querySelectorAll('[data-cart-drawer-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
  };

  const renderCart = (cart) => {
    updateCartCount(cart);

    const items = document.querySelector('[data-cart-items]');
    const subtotal = document.querySelector('[data-cart-subtotal]');
    const footer = document.querySelector('[data-cart-footer]');

    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (footer) footer.hidden = cart.item_count === 0;
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML = '<div class="empty"><p class="serif">Your bag is empty.</p><a class="link-u" href="/collections/all">Shop fragrances</a></div>';
      return;
    }

    items.innerHTML = cart.items.map((item, index) => `
      <div class="it">
        <a class="fr" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ''}</a>
        <div>
          <a href="${escapeHtml(item.url)}"><b>${escapeHtml(item.product_title)}</b></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}
          <div class="q">
            <button type="button" data-cart-line="${index + 1}" data-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-line="${index + 1}" data-cart-quantity="${item.quantity + 1}" aria-label="Increase quantity">＋</button>
          </div>
          <button class="rm" type="button" data-cart-line="${index + 1}" data-cart-quantity="0">Remove</button>
        </div>
        <span>${money(item.final_line_price)}</span>
      </div>
    `).join('');
  };

  const refreshCart = async () => {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  };

  const syncBodyLock = () => {
    document.body.classList.toggle(
      'lock',
      Boolean(
        drawer()?.classList.contains('on') ||
        document.querySelector('[data-pl-menu]')?.classList.contains('on')
      )
    );
  };

  const openCart = async () => {
    const panel = drawer();
    if (!panel) return;

    panel.classList.add('on');
    panel.setAttribute('aria-hidden', 'false');
    veil()?.classList.add('on');
    syncBodyLock();

    await refreshCart();
    panel.querySelector('[data-cart-close]')?.focus();
  };

  const closeCart = () => {
    drawer()?.classList.remove('on');
    drawer()?.setAttribute('aria-hidden', 'true');
    veil()?.classList.remove('on');
    syncBodyLock();
  };

  const changeCartLine = async (line, quantity) => {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity)
      })
    });

    if (!response.ok) throw new Error('Your bag could not be updated.');
    renderCart(await response.json());
  };

  const addVariant = async (id, quantity = 1, properties = {}) => {
    if (!id) {
      throw new Error('Choose the Shopify product for this section in the theme editor.');
    }

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(id),
          quantity,
          properties
        }]
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'This item could not be added.');
    }

    return refreshCart();
  };

  /* =========================================
     PRECIOUS LIQUID — MEMBER ACCESS / KLAVIYO
     ========================================= */
  const PL_HIDE_LEGACY_ACCESS = true;
  const PL_SHOW_GOLD_MEMBER_BUTTON = true;

  const initMemberAccess = () => {
    const goldButton = document.querySelector('[data-pl-member-access]');

    if (goldButton) {
      goldButton.hidden = !PL_SHOW_GOLD_MEMBER_BUTTON;
    }

    // Open the existing Klaviyo discount form when the gold button is clicked.
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-pl-member-access]');
      if (!trigger) return;

      event.preventDefault();
      const formId = (trigger.dataset.klaviyoFormId || '').trim();

      if (!formId) {
        toast('Add the Klaviyo form ID in the Precious Liquid header settings.');
        return;
      }

      // _klOnsite.push queues the command even if Klaviyo.js is still loading.
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });

    if (!PL_HIDE_LEGACY_ACCESS) return;

    // Hide only the old launcher with this exact label; do not hide the Klaviyo popup.
    const hideLegacyButton = () => {
      document.querySelectorAll('button, a, [role="button"]').forEach((element) => {
        if (element.matches('[data-pl-member-access]')) return;

        const label = (element.innerText || element.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toUpperCase();

        if (label === 'GET EXCLUSIVE ACCESS') {
          element.classList.add('pl-legacy-access-hidden');
          element.setAttribute('aria-hidden', 'true');
        }
      });
    };

    hideLegacyButton();

    // Klaviyo or an app may inject the old launcher after the page loads.
    const legacyObserver = new MutationObserver(hideLegacyButton);
    legacyObserver.observe(document.body, { childList: true, subtree: true });
  };


  const initBackgroundAudio = () => {
    const audio = document.getElementById('PLBackgroundAudio');
    const button = document.querySelector('[data-pl-audio-toggle]');

    if (!audio || !button) return;

    const preferenceKey = 'plBackgroundAudioPreference';
    let preference = 'auto';

    try {
      preference = localStorage.getItem(preferenceKey) || 'auto';
    } catch (error) {
      preference = 'auto';
    }

    audio.loop = true;
    audio.volume = 0.10;

    const updateButton = (isPlaying) => {
      button.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-pressed', String(isPlaying));
      button.setAttribute(
        'aria-label',
        isPlaying ? 'Mute Faith and Glory background music' : 'Play Faith and Glory background music'
      );
      button.setAttribute(
        'title',
        isPlaying ? 'Mute Faith and Glory background music' : 'Play Faith and Glory background music'
      );
      const icon = button.querySelector('[data-pl-audio-icon]');
      if (icon) icon.textContent = isPlaying ? '♫' : '♪';
    };

    const savePreference = (value) => {
      preference = value;
      try {
        localStorage.setItem(preferenceKey, value);
      } catch (error) {
        // Audio controls continue to work if browser storage is unavailable.
      }
    };

    const playAudio = async () => {
      try {
        audio.volume = 0.10;
        await audio.play();
        updateButton(true);
        return true;
      } catch (error) {
        updateButton(false);
        return false;
      }
    };

    const pauseAudio = () => {
      audio.pause();
      updateButton(false);
    };

    const removeFirstInteractionListeners = () => {
      document.removeEventListener('pointerdown', startAfterInteraction, true);
      document.removeEventListener('keydown', startAfterInteraction, true);
    };

    const startAfterInteraction = (event) => {
      if (event.target && event.target.closest && event.target.closest('[data-pl-audio-toggle]')) {
        return;
      }

      removeFirstInteractionListeners();

      if (preference !== 'off' && audio.paused) {
        playAudio();
      }
    };

    button.addEventListener('click', async () => {
      removeFirstInteractionListeners();

      if (audio.paused) {
        savePreference('on');
        await playAudio();
      } else {
        savePreference('off');
        pauseAudio();
      }
    });

    audio.addEventListener('play', () => updateButton(true));
    audio.addEventListener('pause', () => updateButton(false));
    audio.addEventListener('ended', () => updateButton(false));

    updateButton(false);

    // Try automatic playback. Browsers may block sound until the visitor interacts.
    if (preference !== 'off') {
      playAudio();
      document.addEventListener('pointerdown', startAfterInteraction, true);
      document.addEventListener('keydown', startAfterInteraction, true);
    }
  };


  /* DAILY VERSE */
  const initDailyVerse = () => {
    const modal = document.querySelector('[data-daily-verse]');
    if (!modal) return;

    const verses = [
      { text: "The LORD is my shepherd; I shall not want.", reference: "Psalm 23:1" },
      { text: "Trust in the LORD with all thine heart; and lean not unto thine own understanding.", reference: "Proverbs 3:5" },
      { text: "I can do all things through Christ which strengtheneth me.", reference: "Philippians 4:13" },
      { text: "Fear thou not; for I am with thee: be not dismayed, for I am thy God.", reference: "Isaiah 41:10" },
      { text: "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil.", reference: "Jeremiah 29:11" },
      { text: "Be still, and know that I am God.", reference: "Psalm 46:10" },
      { text: "Come unto me, all ye that labour and are heavy laden, and I will give you rest.", reference: "Matthew 11:28" },
      { text: "And we know that all things work together for good to them that love God.", reference: "Romans 8:28" },
      { text: "Be strong and of a good courage; be not afraid, neither be thou dismayed.", reference: "Joshua 1:9" },
      { text: "This is the day which the LORD hath made; we will rejoice and be glad in it.", reference: "Psalm 118:24" },
      { text: "For God so loved the world, that he gave his only begotten Son.", reference: "John 3:16" },
      { text: "O taste and see that the LORD is good: blessed is the man that trusteth in him.", reference: "Psalm 34:8" },
      { text: "Charity suffereth long, and is kind; charity envieth not.", reference: "1 Corinthians 13:4" },
      { text: "For we are his workmanship, created in Christ Jesus unto good works.", reference: "Ephesians 2:10" },
      { text: "My help cometh from the LORD, which made heaven and earth.", reference: "Psalm 121:2" },
      { text: "Let your light so shine before men, that they may see your good works.", reference: "Matthew 5:16" },
      { text: "They that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles.", reference: "Isaiah 40:31" },
      { text: "Rejoicing in hope; patient in tribulation; continuing instant in prayer.", reference: "Romans 12:12" },
      { text: "Delight thyself also in the LORD; and he shall give thee the desires of thine heart.", reference: "Psalm 37:4" },
      { text: "For we walk by faith, not by sight.", reference: "2 Corinthians 5:7" },
      { text: "Now faith is the substance of things hoped for, the evidence of things not seen.", reference: "Hebrews 11:1" },
      { text: "And whatsoever ye do, do it heartily, as to the Lord, and not unto men.", reference: "Colossians 3:23" },
      { text: "Thy word is a lamp unto my feet, and a light unto my path.", reference: "Psalm 119:105" },
      { text: "Every good gift and every perfect gift is from above.", reference: "James 1:17" },
      { text: "The fruit of the Spirit is love, joy, peace, longsuffering, gentleness, goodness, faith.", reference: "Galatians 5:22" },
      { text: "What time I am afraid, I will trust in thee.", reference: "Psalm 56:3" },
      { text: "Now the God of hope fill you with all joy and peace in believing.", reference: "Romans 15:13" },
      { text: "Casting all your care upon him; for he careth for you.", reference: "1 Peter 5:7" },
      { text: "Peace I leave with you, my peace I give unto you.", reference: "John 14:27" },
      { text: "For the LORD is good; his mercy is everlasting; and his truth endureth to all generations.", reference: "Psalm 100:5" },
      { text: "It is of the LORD'S mercies that we are not consumed, because his compassions fail not.", reference: "Lamentations 3:22" }
    ];

    const today = new Date();
    const localDay = Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );

    const firstDay = Date.UTC(2026, 9, 30);
    const dayOffset = Math.floor((localDay - firstDay) / 86400000);

    const verse = verses[
      ((dayOffset % verses.length) + verses.length) % verses.length
    ];

    const date = modal.querySelector('[data-verse-date]');
    const quote = modal.querySelector('[data-verse-quote]');
    const reference = modal.querySelector('[data-verse-reference]');
    const listen = modal.querySelector('[data-verse-listen]');
    const closeButton = modal.querySelector('.verse-close');

    const dateParts = [
      today.getFullYear(),
      String(today.getMonth() + 1).padStart(2, '0'),
      String(today.getDate()).padStart(2, '0')
    ];

    date.textContent = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }).format(today);

    date.dateTime = dateParts.join('-');
    quote.textContent = '“' + verse.text + '”';
    reference.textContent = verse.reference;

    const resetListen = () => {
      listen.setAttribute('aria-pressed', 'false');
      listen.innerHTML = '<span aria-hidden="true">▶</span> Listen to verse';
    };

    const closeModal = () => {
      window.speechSynthesis?.cancel();
      resetListen();
      modal.hidden = true;
      document.body.classList.remove('verse-open');
    };

    const showModal = () => {
      if (!modal.hidden) return;

      modal.hidden = false;
      document.body.classList.add('verse-open');
      closeButton?.focus({ preventScroll: true });
    };

    modal.querySelectorAll('[data-verse-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    listen.addEventListener('click', () => {
      if (!('speechSynthesis' in window)) {
        listen.textContent = 'Audio unavailable';
        return;
      }

      if (listen.getAttribute('aria-pressed') === 'true') {
        window.speechSynthesis.cancel();
        resetListen();
        return;
      }

      window.speechSynthesis.cancel();

      const speech = new SpeechSynthesisUtterance(
        verse.text + ' ' + verse.reference + '. King James Version.'
      );

      speech.lang = 'en-US';
      speech.rate = .88;
      speech.onend = resetListen;
      speech.onerror = resetListen;

      listen.setAttribute('aria-pressed', 'true');
      listen.innerHTML = '<span aria-hidden="true">■</span> Stop listening';

      window.speechSynthesis.speak(speech);
    });

    /* First appearance after 45 seconds, then every 45 seconds. */
    window.setInterval(showModal, 45000);
  };

  const init = () => {
    document.documentElement.classList.add('loaded');

    initMemberAccess();
    initBackgroundAudio();
    initDailyVerse();

    const header = document.getElementById('PLHeader');

    const onScroll = () => {
      if (header) {
        header.classList.toggle(
          'solid',
          window.scrollY > 60 ||
          !document.body.classList.contains('template-index')
        );
      }
    };

    onScroll();
    addEventListener('scroll', onScroll, { passive: true });

    const menu = document.querySelector('[data-pl-menu]');

    document.querySelector('[data-pl-menu-open]')?.addEventListener('click', () => {
      menu?.classList.add('on');
      syncBodyLock();
    });

    document.querySelector('[data-pl-menu-close]')?.addEventListener('click', () => {
      menu?.classList.remove('on');
      syncBodyLock();
    });

    menu?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menu.classList.remove('on');
        syncBodyLock();
      });
    });

    const tickerItems = [...document.querySelectorAll('[data-pl-ticker] span')];

    if (tickerItems.length > 1) {
      let index = 0;

      setInterval(() => {
        tickerItems[index].classList.remove('on');
        index = (index + 1) % tickerItems.length;
        tickerItems[index].classList.add('on');
      }, 3800);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.rv').forEach((el) => observer.observe(el));

    const heroVideo = document.querySelector('.pl-hero-video');
    const fallback = document.getElementById('PLHeroFallback');

    heroVideo?.addEventListener('loadeddata', () => {
      if (fallback) fallback.style.opacity = '0';
    });

    document.querySelector('[data-video-toggle]')?.addEventListener('click', (event) => {
      if (!heroVideo) return;

      if (heroVideo.paused) {
        heroVideo.play();
        event.currentTarget.textContent = 'Ⅱ';
        event.currentTarget.setAttribute('aria-label', 'Pause video');
      } else {
        heroVideo.pause();
        event.currentTarget.textContent = '▶';
        event.currentTarget.setAttribute('aria-label', 'Play video');
      }
    });

    const rail = document.querySelector('[data-product-rail]');
    const progress = document.querySelector('[data-rail-progress]');
    const previous = document.querySelector('[data-rail-prev]');
    const next = document.querySelector('[data-rail-next]');

    const setProgress = () => {
      if (!rail || !progress || !rail.scrollWidth) return;

      const max = Math.max(1, rail.scrollWidth - rail.clientWidth);
      const visible = Math.min(100, rail.clientWidth / rail.scrollWidth * 100);

      progress.style.width = `${visible}%`;
      progress.style.left = `${rail.scrollLeft / max * (100 - visible)}%`;

      previous?.toggleAttribute('disabled', rail.scrollLeft <= 2);
      next?.toggleAttribute('disabled', rail.scrollLeft >= max - 2);
    };

    previous?.addEventListener('click', () => {
      rail?.scrollBy({
        left: -rail.clientWidth * .9,
        behavior: 'smooth'
      });
    });

    next?.addEventListener('click', () => {
      rail?.scrollBy({
        left: rail.clientWidth * .9,
        behavior: 'smooth'
      });
    });

    rail?.addEventListener('scroll', setProgress, { passive: true });
    addEventListener('resize', setProgress, { passive: true });
    setProgress();

    document.addEventListener('click', async (event) => {
      const open = event.target.closest('[data-cart-open]');

      if (open) {
        event.preventDefault();
        await openCart();
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        event.preventDefault();
        closeCart();
        return;
      }

      const line = event.target.closest('[data-cart-line]');

      if (line) {
        event.preventDefault();
        line.disabled = true;

        try {
          await changeCartLine(line.dataset.cartLine, line.dataset.cartQuantity);
        } catch (error) {
          toast(error.message);
        }

        return;
      }

      const quick = event.target.closest('[data-quick-add]');
      if (!quick) return;

      event.preventDefault();
      quick.disabled = true;

      try {
        await addVariant(quick.dataset.quickAdd);
        toast('Added to your bag.');
        await openCart();
      } catch (error) {
        toast(error.message);
      } finally {
        quick.disabled = false;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCart();
    });

    document.querySelectorAll('#PLProductForm').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const submit = form.querySelector('[type="submit"]');
        submit.disabled = true;

        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'This item could not be added.');
          }

          toast('Added to your bag.');
          await openCart();
        } catch (error) {
          toast(error.message);
        } finally {
          submit.disabled = false;
        }
      });
    });

    document.querySelectorAll('[data-discovery-builder]').forEach((builder) => {
      const picks = [];
      const slots = builder.querySelector('[data-discovery-slots]');
      const message = builder.querySelector('[data-discovery-message]');
      const add = builder.querySelector('[data-discovery-add]');
      const buttons = [...builder.querySelectorAll('[data-discovery-pick]')];
      const options = [...builder.querySelectorAll('[data-set-size]')];
      const familyButtons = [...builder.querySelectorAll('[data-family-choice]')];
      const familyProducts = [...builder.querySelectorAll('[data-family-products]')];

      const displayImage = builder.closest('.disc')?.querySelector(
        '[data-discovery-display-image]'
      );

      let activeOption = options.find(
        (option) => option.getAttribute('aria-pressed') === 'true'
      ) || options[0];

      let setSize = Number(activeOption?.dataset.setSize || 4);

      const render = () => {
        builder.dataset.activeSize = String(setSize);

        slots.innerHTML = Array.from({ length: setSize }, (_, index) => {
          const pick = picks[index];

          return pick
            ? `<div class="slot full"><img src="${escapeHtml(pick.image)}" alt=""><span>${escapeHtml(pick.title)}</span></div>`
            : '<div class="slot">Empty</div>';
        }).join('');

        buttons.forEach((button) => {
          const selected = picks.some((pick) => pick.id === button.dataset.id);

          button.setAttribute('aria-pressed', String(selected));
          button.disabled = !selected && picks.length >= setSize;
        });

        const left = setSize - picks.length;

        message.textContent = left
          ? `Choose ${left} more fragrance${left === 1 ? '' : 's'}`
          : 'Your collection is complete';

        add.disabled = left !== 0 || !activeOption?.dataset.productVariant;

        const price = activeOption?.querySelector('span')?.textContent?.split('·').pop()?.trim();

        add.textContent = `Add collection${price ? ` — ${price}` : ''}`;
      };

      options.forEach((option) => {
        option.addEventListener('click', () => {
          activeOption = option;
          setSize = Number(option.dataset.setSize || 4);

          options.forEach((item) => {
            item.setAttribute('aria-pressed', String(item === option));
          });

          if (picks.length > setSize) {
            picks.splice(setSize);
          }

          if (displayImage && option.dataset.image) {
            displayImage.src = option.dataset.image;
          }

          render();
        });
      });

      familyButtons.forEach((familyButton) => {
        familyButton.addEventListener('click', () => {
          const family = familyButton.dataset.familyChoice;

          familyButtons.forEach((button) => {
            const active = button === familyButton;

            button.setAttribute('aria-pressed', String(active));
            button.setAttribute('aria-expanded', String(active));
          });

          familyProducts.forEach((container) => {
            container.hidden = container.dataset.familyProducts !== family;
          });
        });
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const index = picks.findIndex(
            (pick) => pick.id === button.dataset.id
          );

          if (index >= 0) {
            picks.splice(index, 1);
          } else if (picks.length < setSize) {
            picks.push({
              id: button.dataset.id,
              title: button.dataset.title,
              image: button.dataset.image
            });
          }

          render();
        });
      });

      add.addEventListener('click', async () => {
        add.disabled = true;

        const properties = {};

        picks.forEach((pick, index) => {
          properties[`Fragrance ${index + 1}`] = pick.title;
        });

        try {
          await addVariant(
            activeOption.dataset.productVariant,
            1,
            properties
          );

          toast('Your discovery collection was added.');
          picks.splice(0);
          await openCart();
        } catch (error) {
          toast(error.message);
        }

        render();
      });

      render();
    });

    refreshCart().catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
